var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.classList },
    _vm._l(_vm.mappedStatuses, function (status) {
      return _c(
        "div",
        {
          key: status.statusName,
          staticClass: "_flex _ai-c _gap-1 _tc--base",
          attrs: { "data-qa": status.dataQa },
        },
        [
          _c("base-indicator-dot", { attrs: { color: status.colorCode } }),
          _vm._v("\n        " + _vm._s(status.statusName) + "\n        "),
          status.tooltipText
            ? [
                _c("tooltip", {
                  attrs: {
                    text: status.tooltipText,
                    "icon-name": "circle-info",
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }